import React, {lazy, Suspense} from 'react'
import t from 'format-message'

import {useParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Reports = lazy(() => import('./components/pages/Index').then(({Index}) => ({default: Index})))

/**
 * @deprecated Use the `NewItemAnalysis` component instead.
 */
const QuizAndItemAnalysis = lazy(() =>
  import('./components/pages/QuizAndItemAnalysis').then(({QuizAndItemAnalysis}) => ({
    default: QuizAndItemAnalysis,
  })),
)

const NewItemAnalysis = lazy(() =>
  import('./components/pages/NewItemAnalysis').then(({NewItemAnalysis}) => ({
    default: NewItemAnalysis,
  })),
)

const OutcomeAnalysis = lazy(() =>
  import('./components/pages/OutcomeAnalysis').then(({OutcomeAnalysis}) => ({
    default: OutcomeAnalysis,
  })),
)

export function ReportsPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Reports'))

  return (
    <Suspense>
      <Reports activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

export function QuizAndItemAnalysisPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Reports - Analysis'))

  return (
    <Suspense>
      <QuizAndItemAnalysis activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

export function NewQuizItemAnalysisPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Reports - Analysis'))

  return (
    <Suspense>
      <NewItemAnalysis activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

export function OutcomeAnalysisPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Reports - Outcomes'))

  return (
    <Suspense>
      <OutcomeAnalysis activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the reporting module.
 */
export const reportingRoutes = [
  {
    index: true,
    element: <ReportsPage />,
  },
  {
    path: 'quiz_item_analysis',
    element: <QuizAndItemAnalysisPage />,
  },
  {
    path: 'new_quiz_item_analysis',
    element: <NewQuizItemAnalysisPage />,
  },
  {
    path: 'outcome_analysis',
    element: <OutcomeAnalysisPage />,
  },
]
